<template>  
	<div class="pagination" v-if="total">
      <button @click="changePageNo(pageNo-1)" :disabled="pageNo === 1">上一页</button>
      <button @click="changePageNo(1)" v-show="startEnd.start !== 1">1</button>
      <span v-show="startEnd.start > 2">···</span>

      <!-- 生成连续页 -->
      <button 
        v-for="(n,index) in (startEnd.end-startEnd.start + 1)" 
        :key="index"
        :class="{active:(index+startEnd.start) === pageNo}"
        @click="changePageNo(index+startEnd.start)"
      >
        {{index+startEnd.start}}
      </button>

      <span v-show="startEnd.end < totalPage-1">···</span>
      <button @click="changePageNo(totalPage)" v-show="startEnd.end !== totalPage">{{totalPage}}</button>
      <button @click="changePageNo(pageNo+1)" :disabled="pageNo === totalPage">下一页</button>

      <span>共 {{total}} 条</span>
    </div>
</template>

<script>    
  export default {      
    name: "Pagination",   
    props:['total','pageSize','pageNo','continues','changePageNo'],
    computed:{
      // 计算总页数
      totalPage(){
        return Math.ceil(this.total / this.pageSize)
      },
      // 计算连续页的起始页、结束页
      startEnd(){
        // 获取外部传入的各种参数
        const {continues,pageNo,totalPage} = this
        let start = 0 //起始页初始值
        let end = 0 //结束页初始值

        // 判断一下目前的情况是不是一个“大变态”（你要求的连续页数，比我倾家荡产的总页数都要多，推都不推，都给你）
        if(continues > totalPage){
          start = 1
          end = totalPage
        }else{
          // 标准情况（正常左推，右推）
          start = pageNo - (continues - 1)/2
          end = pageNo + (continues - 1)/2
          // 判断左边是否“冒了”（start是否小于1）
          if(start < 1){ 
            start = 1
            end = continues
          }
          // 判断右边是否“冒了”（end是否大于totalPage）
          if(end > totalPage){ 
            start = totalPage - continues + 1
            end = totalPage
          }
        }
        return {start,end}
      }
    }
  };
</script>

<style lang="less" scoped>
  .pagination {
    text-align: center;

    button {
      margin: 0 5px;
      background-color: #f4f4f5;
      color: gray;
      outline: none;
      border-radius: 2px;
      padding: 0 4px;
      vertical-align: top;
      display: inline-block;
      font-size: 13px;
      min-width: 35.5px;
      height: 28px;
      line-height: 28px;
      cursor: pointer;
      box-sizing: border-box;
      text-align: center;
      border: 0;

      &[disabled] {
        color: #c0c4cc;
        cursor: not-allowed;
      }

      &.active {
        cursor: not-allowed;
        background-color: #c81623;
        color: #fff;
      }
    }

    span {
      display: inline-block;
      line-height: 28px;
      font-size: 14px;
      color: gray;
      vertical-align: middle;
    }
  }
</style>